module.exports = __webpack_public_path__ + "img/title.502c1d2a.png";